import React from 'react'
import { Snapshot } from '../domain/Snapshot'
import LargeNumber from '../helper/large-number'
import Milliseconds from '../helper/milliseconds'
import Percent from '../helper/percent'
import SnapshotModel from './snapshot/snapshotModel'
import { TimeRangeLabelComponent } from './timeRangeLabel'

interface Props {
    data: Snapshot
    snapshot: SnapshotModel
}

class Introspection extends React.Component<Props> {
    public render() {
        return (
            <div className="box-header">
                <h2 className="box-title">
                    <div className="pull-right">
                        <Milliseconds value={this.props.data.report.slices.after.responseTime * 1000} /> <small>95% Percentile</small> |{' '}
                        <LargeNumber value={this.props.data.report.slices.after.requests} /> <small>Requests</small> |{' '}
                        <Percent value={this.props.data.report.slices.after.errorRate / 100} class="error" /> <small>Failures</small> |{' '}
                        <LargeNumber value={this.props.data.profiles.total} /> <small>Traces</small>
                    </div>
                    Introspection
                    <span className="tw-ml-12">
                        <TimeRangeLabelComponent
                            startDate={this.props.snapshot.getStartDate()}
                            endDate={this.props.snapshot.getEndDate()}
                            isCurrent={false}
                        />
                    </span>
                </h2>
            </div>
        )
    }
}

export default Introspection
